var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6048 0C11.5119 0.929501 11.8088 1.85941 12.459 2.53375C11.5119 2.58869 10.6387 3.04408 10.0632 3.79167C10.156 2.86176 9.85873 1.93226 9.20898 1.25792C10.156 1.18508 11.0289 0.729276 11.6048 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04851 0.541992C5.95822 1.67789 6.31937 2.72602 7.04167 3.44259C6.01223 3.4773 4.98319 4.00156 4.24316 4.87533C4.33345 3.75698 3.9723 2.6913 3.25 1.97474C4.27904 1.94002 5.30847 1.41576 6.04851 0.541992Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3528 4.875C11.2824 5.54297 11.494 6.19231 11.9167 6.69298C11.2824 6.73025 10.7012 7.06403 10.3139 7.58333C10.3843 6.91536 10.1727 6.26643 9.75 5.76535C10.3843 5.72849 10.9655 5.3943 11.3528 4.875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9671L6.08192 5.41699L7.04167 6.45062L0.959745 13.0003L0 11.9671Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.11329L8.15136 3.79199L9.20833 4.63736L7.55697 5.95866L6.5 5.11329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.5f851d731b17160af4f585050050d026.svg";
export { ForwardRef as ReactComponent };